import React from "react";
import { Button, Form } from "react-bootstrap";

const FileUpload = ({
  name,
  value,
  onChange,
  onRemove,
  label,
  error,
  required = false,
}) => {
  const handleSelect = (e) => {
    onChange?.(e.currentTarget.files[0]);
    e.currentTarget.value = "";
  };

  return (
    <Form.Group className="mb-3">
      <Form.Label>
        {label} {required && "*"}
      </Form.Label>
      <div className="d-flex">
        <Form.Control
          id={name}
          style={{ display: "none" }}
          type="file"
          onChange={handleSelect}
        />
        {!value && (
          <Button variant="primary" as="label" htmlFor={name}>
            Datei auswählen...
          </Button>
        )}
        {value && (
          <>
            <div className="form-control-file mr-2">{value.name}</div>
            <Button variant="danger" onClick={onRemove}>
              Löschen
            </Button>
          </>
        )}
      </div>
      {error && <small className="text-danger">{error}</small>}
    </Form.Group>
  );
};

export default FileUpload;
